<template>
	<div class="user-role-container">
		<!-- 面包屑导航区域 -->		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<!-- 搜索与添加区域 -->
			<div class="search-area">
					<el-form ref="searchForm" :model="rolePageReq" label-width="70px" inline size="small">
						<el-form-item label="角色名称:">
							<el-input :clearable="true" v-model="rolePageReq.keyword" placeholder="请输入角色名称" style="width: 150px;" />
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="getRoleList()">查询</el-button>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="initAdd()">+ 添加</el-button>
						</el-form-item>
					</el-form>
				</div>
			<!-- 角色列表区 -->
			<el-table :data="roleList" border stripe :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
				<el-table-column type="index" width="60"></el-table-column>
				<el-table-column label="角色名称" prop="roleName"></el-table-column>
				<el-table-column label="角色描述" prop="comments"></el-table-column>
				<el-table-column label="修改时间" prop="updateTime"></el-table-column>
				<el-table-column label="创建时间" prop="createTime" width="180"></el-table-column>
				<el-table-column label="操作" width="180px">
					<template slot-scope="scope">
						<el-button type="primary" icon="el-icon-edit" size="mini" @click="roleInfoEdit(scope.row.roleId)">编辑</el-button>
						<!-- <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRole(scope.row.roleId)">删除</el-button> -->
						<el-tooltip class="item" effect="dark" content="修改角色权限" placement="top" :enterable="false">
							<el-button type="warning" icon="el-icon-setting" size="mini" @click="getRoleAuthority(scope.row.roleId)"></el-button>
						</el-tooltip>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页区域 -->
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="rolePageReq.page"
			 :page-sizes="[10,20,50,100]" :page-size="rolePageReq.limit" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
			<!-- 添加角色信息 -->
			<el-dialog :visible.sync="addRoledialogVisible" width="30%">
				<template slot="title">
					<div style="line-height: 24px;font-size: 18px;color: #FFFFFF;">添加角色</div>
				</template>
				<!-- form表单 -->
				<el-form :model="roleInfo" status-icon :rules="addRoleRules" ref="roleInfo" label-width="100px" class="demo-ruleForm">
					<el-form-item label="角色名称" prop="roleName">
						<el-input type="text" v-model="roleInfo.roleName" autocomplete="off" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="角色描述" prop="comments">
						<el-input v-model.number="roleInfo.comments" size="small" :clearable=true></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="addRoledialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="addRole()">确 定</el-button>
				</span>
			</el-dialog>
			<!-- 编辑角色信息 -->
			<el-dialog title="编辑角色" :visible.sync="updateRoledialogVisible" width="30%">
				<!-- form表单 -->
				<el-form :model="roleInfo" status-icon :rules="addRoleRules" ref="roleInfo" label-width="100px" class="demo-ruleForm">
					<el-form-item label="角色名称" prop="roleName">
						<el-input type="text" v-model="roleInfo.roleName" autocomplete="off" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="角色描述" prop="comments">
						<el-input v-model.number="roleInfo.comments" size="small" :clearable=true></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="updateRoledialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="roleInfoUpdate()">确 定</el-button>
				</span>
			</el-dialog>
			<!-- 权限修改 -->
			<el-dialog title="权限分配" :visible.sync="updateDialogVisible" width="30%">
				<div style="height: 35rem;overflow: auto;padding: 0.625rem 1.25rem;border: #e8eaec 0.0625rem solid;margin-left: 1.2rem;">
					<!-- form表单 -->
					<el-tree :data="authTree" ref="tree" :check-strictly="true" show-checkbox node-key="id" :default-expand-all="true"
					 :default-checked-keys="expandedKeys" :props="defaultProps" @check="clickDeal">
					</el-tree>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="updateDialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="updateUserRole()">确 定</el-button>
				</span>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				rolePageReq: {
					//当前页数
					page: 1,
					//当前每页多少条
					limit: 10,
					keyword: '',
				},
				roleList: [],
				total: 0,
				//控制添加角色信息对话框显示与隐藏
				addRoledialogVisible: false,
				updateDialogVisible: false,
				updateRoledialogVisible: false,
				roleInfo: {
					roleName: '',
					comments: '',
				},
				authTree: [],
				defaultProps: {
					children: 'subMenus',
					label: 'name'
				},
				expandedKeys: [],
				addRoleRules: {
					//验证角色名是否合法
					roleName: [{
							required: true,
							message: '请输入角色名称',
							trigger: 'blur',
						},
						{
							min: 2,
							max: 16,
							message: '长度在 2 到 16 个字符',
							trigger: 'blur',
						}
					],
					//验证角色描述是否合法
					comments: [{
							required: true,
							message: '请输入角色描述',
							trigger: 'blur',
						},
						{
							min: 2,
							max: 16,
							message: '长度在 2 到 16 个字符',
							trigger: 'blur',
						}
					],
				},
				authorityUpdateReq: {
					roleId: 0,
					authIds: ''
				},
				keyword: '',
			}
		},
		created() {
			this.getRoleList()
		},
		methods: {
			async getRoleList() {
				const {
					data: res
				} = await this.$http.post('/system/role/list', this.rolePageReq)
				if (res.code != 200) return this.$message.error(res.msg)
				this.roleList = res.data
				this.total = res.count
			},
			//监听pagesize变化
			handleSizeChange(pageSize) {
				this.rolePageReq.limit = pageSize
				this.getRoleList()
			},
			//监听页数变化
			handleCurrentChange(pageNum) {
				this.rolePageReq.page = pageNum
				this.getRoleList()
			},
			userStateChanged(roleInfo) {
				this.$http.post('/system/role/updateState', {
						userId: roleInfo.userId,
						state: roleInfo.state,
					}).then((res) => {
						console.log(res)
					})
			},
			initAdd() {
				this.roleInfo = {}
				this.addRoledialogVisible = true
			},
			addRole() {
				this.$http.post('/system/role/add', this.roleInfo).then((res) => {
					if (res.data.code == 200) {
						this.addRoledialogVisible = false
						this.$message.success(res.data.msg)
						this.getRoleList()
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			getRoleAuthority(roleId) {
				this.authorityUpdateReq.roleId = roleId;
				this.$http.get('/system/role/authTree/' + roleId).then((res) => {
					this.updateDialogVisible = true
					this.authTree = res.data.data
					if (res.data.data.length > 0) {
						let arr = [];
						for (var index in res.data.data) {
							if (res.data.data[index].checked) {
								arr.push(res.data.data[index].id)
								if (res.data.data[index].subMenus.length > 0) {
									for (var index2 in res.data.data[index].subMenus) {
										if (res.data.data[index].subMenus[index2].checked) {
											arr.push(res.data.data[index].subMenus[index2].id)
											if (res.data.data[index].subMenus[index2].subMenus.length > 0) {
												for(var index3 in res.data.data[index].subMenus[index2].subMenus){
													if(res.data.data[index].subMenus[index2].subMenus[index3].checked){
														arr.push(res.data.data[index].subMenus[index2].subMenus[index3].id)
													}
												}
											}
										}
									}
								}
							}
						}
						console.log("所有权限id", arr)
						this.expandedKeys = arr;
					}
				})
			},
			updateUserRole() {
				this.authorityUpdateReq.authIds = JSON.stringify(this.$refs.tree.getCheckedKeys())
				this.$http.post('/system/role/updateRoleAuth', this.authorityUpdateReq).then(res => {
					if (res.data.code == 200) {
						this.updateDialogVisible = false
						this.$message.success(res.data.msg)
					} else {
						this.updateDialogVisible = false
						this.$message.error(res.data.msg)
					}

				})
			},
			clickDeal(currentObj, treeStatus) {
				// 用于：父子节点严格互不关联时，父节点勾选变化时通知子节点同步变化，实现单向关联。
				let selected = treeStatus.checkedKeys.indexOf(currentObj.id) // -1未选中
				// 选中
				if (selected !== -1) {
					// 子节点只要被选中父节点就被选中
					this.selectedParent(currentObj)
					// 统一处理子节点为相同的勾选状态
					this.uniteChildSame(currentObj, true)
				} else {
					// 未选中 处理子节点全部未选中
					if (currentObj.subMenus) {
						this.uniteChildSame(currentObj, false)
					}
				}
			},
			uniteChildSame(treeList, isSelected) {
				this.$refs.tree.setChecked(treeList.id, isSelected)
				if (treeList.subMenus !== undefined) {
					for (let i = 0; i < treeList.subMenus.length; i++) {
						this.uniteChildSame(treeList.subMenus[i], isSelected)
					}
				}
			},
			// 统一处理父节点为选中
			selectedParent(currentObj) {
				let currentNode = this.$refs.tree.getNode(currentObj)
				if (currentNode.parent.key !== undefined) {
					this.$refs.tree.setChecked(currentNode.parent, true)
					this.selectedParent(currentNode.parent)
				}
			},
			deleteRole(roleId) {
				this.$confirm("确认删除该条数据吗？", {
					title: "提示",
					type: 'warning',
				}).then(resc => {
					this.$http.post('system/role/delete', {
						roleId: roleId
					}).then(res => {
						if (res.data.code == 200) {
							this.getRoleList()
							this.$message.success(res.data.msg)
						}
					})
				})

			},
			roleInfoEdit(roleId) {
				this.$http.get('/system/role/getByRoleId/' + roleId).then(res => {
					if (res.data.code == 200) {
						this.roleInfo = res.data.data
						this.updateRoledialogVisible = true
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},
			roleInfoUpdate() {
				this.$http.post('/system/role/update', this.roleInfo).then(res => {
					if (res.data.code == 200) {
						console.log(res)
						this.getRoleList()
						this.updateRoledialogVisible = false
						this.$message.success(res.data.msg)
						this.roleInfo = {}
					} else {
						this.$message.error(res.data.msg)
					}
				})
			}
		},
	}
</script>

<style>
	.user-role-container {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.box-card {
		flex: 1;
		display: flex;
		flex-direction: column;
		height: 100%;
		overflow: hidden;
	}

	.search-area {
		position: sticky;
		top: 0;
		z-index: 10;
		background-color: #fff;
		padding: 15px 0;
		border-bottom: 1px solid #EBEEF5;
	}
	.el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #3CA757 !important;
		border-color: #3CA757 !important;
	}
</style>
